const lnhStatus = document.querySelector('#lhc_status_container');
const boxThanjai = document.querySelector('.box-chatbot');

const liveChatThanjai = document.querySelector('.icon-type-chat.chatThanjai')
if (liveChatThanjai) {
    liveChatThanjai.addEventListener('click', () => {
        const btnLhc = document.querySelector('#lhc_min');
        const btnCLose = document.querySelector('#lhc_close');
        const remoteWindow = document.querySelector('#lhc_remote_window');
        if(lnhStatus && lnhStatus.classList.contains('hide-status')) {
            hideThanjai();
            if (btnCLose) {
                btnCLose.addEventListener('click',showThanjai);
            }
            if (btnLhc) {
                btnLhc.addEventListener('click', hideThanjai);
            }
            if (remoteWindow) {
                remoteWindow.addEventListener('click',showThanjai);
            }
        } 
    })
}
if(lnhStatus && lnhStatus.classList.contains('hide-status')) {
    hideThanjai();
} 

function showThanjai() {
    if (boxThanjai) {
        if (boxThanjai.classList.contains('d-none')){
            boxThanjai.classList.remove('d-none');
        }
    }
}
function hideThanjai() {
    if (boxThanjai) {
        if (!boxThanjai.classList.contains('d-none')){
            boxThanjai.classList.add('d-none');
        }
    }
}